import { render, staticRenderFns } from "./PreviewBadge.vue?vue&type=template&id=5e91e43a&lang=pug&"
import script from "./PreviewBadge.vue?vue&type=script&lang=ts&"
export * from "./PreviewBadge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports